import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { KeycloakService, UserData } from '../../authentication/keycloak.service';
import { UserProfile, SecurityService } from '../../security/security.service';
import { MessageLevel, PgMessagesService} from '../../shared/services/pg-messages.service';
import { DocumentService} from '../../documents/documents.service';
import { saveAs } from 'file-saver';
import { PgTitleComponent } from '../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule],
})
export class UserProfileComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  userData: UserData | undefined;
  user: UserProfile;
  thumbnail: any;
  currentFiles: FileList | undefined;
  exisitingVersion: number | undefined;

  constructor(
    private _keycloakService: KeycloakService,
    private _securityService: SecurityService,
    private _documentsService: DocumentService,
    private _pgMessagesService: PgMessagesService, private sanitizer: DomSanitizer) {
    this.user = UserProfile.create();
  }

  async ngOnInit() {
    this.title.emit('Profile');
    try {
      const p = await this._securityService.getUserProfile();
      if (p && p.profile) {
        this.exisitingVersion = p.version;
        this.user = p.profile;
        await this.downloadProfileImage();
      }
    } catch {
      this.userData = this._keycloakService.getUser();
      this.user = UserProfile.create({
        portalUserName: this.userData.username,
        fullName: this.userData.fullName,
        email: this.userData.email,
        confirm: false,
      });
    }
  }

  async addOrUpdateUserProfile() {
    if (this.exisitingVersion || this.exisitingVersion === 0) {
      await this._securityService.update(this.user, this.exisitingVersion);
    } else {
      await this._securityService.add(this.user);
    }
  }

  async openUpload(fileEvent: any) {
    this.currentFiles = fileEvent.target.files;
    if (this.currentFiles !== undefined) {
      if (this.currentFiles[0].size > 5000000) {
        confirm('The file size should be less than 5MB');
      } else if (this.currentFiles[0]) {
        const document = await this._documentsService.upload(this.currentFiles[0]);
        this.user.profileImageId = document.id;
        await this.downloadProfileImage();
        await this.addOrUpdateUserProfile();
        this._pgMessagesService.publishMessage({
          message: `Profile Image added to  ${this.user.fullName} profile`,
          topic: 'New Image',
          level: MessageLevel.Info
        });
      }
    } else {
      confirm('Please select a file');
    }
  }

  async downloadProfileImage() {
    if (this.user?.profileImageId) {
      const url = await this._documentsService.getDownloadUrl(this.user.profileImageId);
      this.thumbnail = url;
    }
  }

  downloadFile(fileId: string, fileName: string) {
    this._documentsService.download(fileId).subscribe(b => {
      saveAs(b.body, `${fileName}.p12`);
    }, () => {
      this._pgMessagesService.publishMessage({
        message: 'Could not download this file.',
        level: MessageLevel.Error,
        topic: 'User profile'
      });
    });
  }

  async confirm() {
    this.user.confirm = true;
    await this.addOrUpdateUserProfile();
  }
}
